module.exports = __webpack_public_path__ + "static/media/F3.62539b97.mp3";